export interface RedirectType {
  name: string;
  value: string;
  overrides?: Overrides;
}

export interface Overrides {
  format?: FormatOverrides;
  params?: { [key: string]: any };
}

export interface FormatOverrides {
  sdk_requirement?: string;
  ios_sdk_requirement?: string;
  ios_requirement?: string;
}

export const redirectTypes: RedirectType[] = [
  {
    name: 'Celtra',
    value: 'celtra'
  },
  {
    name: 'OCS',
    value: 'ocs',
    overrides: {
      params: {
        orientation: 'portrait'
      },
      format: {
        ios_requirement: '>=15'
      }
    }
  },
  {
    name: 'DCM',
    value: 'dcm',
    overrides: {
      format: {
        sdk_requirement: '>=4.1.0',
        ios_sdk_requirement: '>=3.1.0'
      }
    }
  },
  {
    name: 'Default',
    value: 'default'
  },
  {
    name: 'MRAID Wrapper',
    value: 'mraid_wrapper'
  },
  {
    name: 'Flashtalking',
    value: 'flashtalking'
  },
  {
    name: 'Adform',
    value: 'adform'
  }
];
